<template>

    <AjanlatBase :titleExtra="titleExtra"
                 v-if="tobbszerzVisible() || csopkedvVisible() || csaladiVisible() || cascoEgyuttVisible()">
generali casco együttkötés azonosító bekérés hiba javítása
            <v-form slot="biztositoi-adatok" ref="ajanlat-adatok">

                <v-layout row wrap>

                    <BnFormField v-if="tobbszerzVisible()" :attributes="generali_tobbszerzkedv_azon" />

                    <BnFormField v-if="csopkedvVisible()" :attributes="generali_cegcsopkedv_azon" />

                    <BnFormField v-if="csaladiVisible()" :attributes="generali_csaladikedv_azon" />

                    <BnFormField v-if="cascoEgyuttVisible()" :attributes="generali_cascokedv_azon" />

                </v-layout>

            </v-form>

    </AjanlatBase>

</template>

<script>
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';
import AjanlatBase from '../KGFBAjanlatBase.vue';
import offerData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/OfferData';

export default {
    name: 'AjanlatAdatokB2_V0',
    components: { AjanlatBase, BnFormField },
    mixins: [offerData],
    methods: {
        tobbszerzVisible() {
            return this.kedvezmenyek.tobbszerz === true;
        },

        csopkedvVisible() {
            return this.kedvezmenyek.csoport === true;
        },

        csaladiVisible() {
            return this.kedvezmenyek.csaladi === true;
        },

        cascoEgyuttVisible() {
            return (this.kedvezmenyek.egyuttcasco === true && !this.egyuttkotve)
                || parseInt(this.$store.getters.tarifaData.szerz_casco, 10) === 5
                || parseInt(this.$store.getters.tarifaData.szerz_casco, 10) === 105;
        },
    },
    data() {
        return {
            generali_tobbszerzkedv_azon: {
                type: 'text',
                label: 'Többszerződés kedvezményt igazoló szerződés szám',
                visible: true,
                editable: true,
                help: true,
                mezo: 'generali_tobbszerzkedv_azon',
                path: 'tarifaData.generali_tobbszerzkedv_azon',
            },
            generali_cegcsopkedv_azon: {
                type: 'text',
                label: 'Cégcsoport kedvezményt igazoló szerződés szám',
                visible: true,
                editable: true,
                help: true,
                mezo: 'generali_cegcsopkedv_azon',
                path: 'tarifaData.generali_cegcsopkedv_azon',
            },
            generali_csaladikedv_azon: {
                type: 'text',
                label: 'Családi kedvezményt igazoló szerződés szám',
                visible: true,
                editable: true,
                help: true,
                mezo: 'generali_csaladikedv_azon',
                path: 'tarifaData.generali_csaladikedv_azon',
            },
            generali_cascokedv_azon: {
                type: 'text',
                label: 'Casco kedvezményt igazoló szerződés szám',
                visible: true,
                editable: true,
                help: true,
                mezo: 'generali_cascokedv_azon',
                path: 'tarifaData.generali_cascokedv_azon',
            },
        };
    },
};
</script>
